<zimmerer-route-ion-wrapper class="ion-page">
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div
      class="main-col withBottomPadding"
      [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages"
      fxLayout="column"
      fxLayoutGap="10px"
    >
      <div fxHide.gt-md fxLayout="column" fxLayoutGap="5px">
        <div style="text-align: center">Jobbörse</div>
        <h2 class="listHeadline">Jetzt erfolgreiche Jobsuche starten!</h2>
      </div>

      <image-slider [fxHide]="!hasSliderImages" [page]="'job'" fxHide.lt-lg></image-slider>

      <app-searchbar
        (onSearch)="changeFilter($event.filter, 'string', $event.value)"
        (onPreflightSearch)="onPreflightSearch($event)"
        [preflightValues]="preflightValues"
        entityTypeIdentifier="job"
      >
      </app-searchbar>

      <!-- <button *ngIf="mobileService.isMobile" class="mobileGrowBtn" (click)="showfilters = !showfilters;">{{showfilters ? 'Filterauswahl schließen' : 'Filter auswählen'}}</button> -->

      <lines-word [word]="'oder'"></lines-word>

      <region-picker-dropdown
        (onCategorySelect)="changeFilter($event.filter, 'number', $event.value)"
        [selectedId]="
          StateService.queryParams.job_category_id != null ? StateService.queryParams.job_category_id : null
        "
      >
      </region-picker-dropdown>

      <!-- MOBILE only - local create button -->
      <button fxHide.gt-md class="orange-button create-btn" (click)="StateService.goto('/job/create', {}, true, true)">
        Beitrag erstellen
      </button>

      <!-- grid -->
      <div class="grid" *ngIf="pagination && pagination.values; else noHits">
        <job-card
          *ngFor="let e of pagination.values"
          [entity]="e"
          #impressionAnchor
          data-entitytype="Job"
          data-id="{{ e.id }}"
        >
        </job-card>
      </div>
      <ng-template #noHits>
        {{ !LoadingService.isLoading ? 'Leider ergab deine Suche mit den eingestellten Filtern keine Treffer.' : '' }}
      </ng-template>

      <app-pagination
        [pagination]="pagination"
        [stateParams]="StateService.queryParams"
        (onGotoPage)="changeFilter($event.filter, 'number', $event.value)"
      >
      </app-pagination>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
